import { Injectable } from '@angular/core';
import {io} from 'socket.io-client';

import { Observable } from 'rxjs';
import {Company} from "../company/models/Company";
import {environment} from "../../../environments/environment";
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  private socket;

  private session = null;
  constructor(private http: HttpClient) {

  }
  private chatbotUrl = environment.baseUrl + '/broker/chat';

  postChatMessage(input) {
    let params = new HttpParams();
    params = params.append('input', input);

    return this.http.get<any>(this.chatbotUrl, {params});
  }

  public connect(url: string, session: string, cb: any){
    this.session = session ? session : null;

    this.socket = io(url);
    let that = this;
    let firstEntry = true;
    this.socket.on('connect', () => {
      this.session = this.session ? this.session : this.socket.id;

      this.socket.emit('session_request', {session_id:  this.session});

      if(firstEntry){
        that.sendMessage('/greet');
        firstEntry = false;
      }

      cb(true);
    });
    this.socket.on('session_confirm', (remote) => {
      console.log(remote);
    });
    this.socket.on('connect_error', (error) => {
      console.log(error);
    });

    this.socket.on('error', (error) => {
      console.log(error);
    });

    this.socket.on('disconnect', (reason) => {
      console.log(reason);
      cb(false);
    });
  }

  public sendMessage(message) {
    this.socket.emit('user_uttered', {message, session_id: this.session});
  }

  public getMessages = () => {
        return Observable.create((observer) => {
            this.socket.on('bot_uttered', (message) => {
                observer.next(message);
            });
        });
  }
}
